module.exports = __webpack_public_path__ + "media/shimmer.bac29968.mp3";